<nav id="app-header-nav-section" class="container-fluid">
  <div class="mh-section-content">
    <ul class="nav primary-navbar nav bg-white flex-column flex-md-row p-0 justify-content-start">
      @for (menuItem of menu; track menuItem.id) {
        <li class="nav-item text-center" [ngClass]="menuItem.cssClass ? menuItem.cssClass : 'pt-md-4'">
          <ng-template [ngxPermissionsOnly]="menuItem.permissionScope" [ngxPermissionsExcept]="menuItem.exceptPermissionScope || []">
            @if (!menuItem.icon) {
              <a [routerLinkActive]="'active'" [id]="menuItem.id" [attr.aria-label]="menuItem.label" class="nav-link" [routerLink]="menuItem.path" (click)="navigateToRoute(menuItem.path)">
                {{ menuItem.label }}
              </a>
            }
            @if (menuItem.icon) {
              <a [routerLinkActive]="'active'" [id]="menuItem.id" [attr.aria-label]="menuItem.label" class="nav-link" [routerLink]="menuItem.path" (click)="navigateToRoute(menuItem.path)">
                <img class="img-fluid my-1" [src]="menuItem.icon" [alt]="menuItem.label" />
                <span class="d-block fw-normal">{{ menuItem.label }}</span>
              </a>
            }
          </ng-template>
        </li>
      }
    </ul>
  </div>
</nav>
